module.exports = __webpack_public_path__ + "img/sea_freight.30bc727c.svg";